import { Box } from '@mui/material'
import { ReactComponent as NextIcon } from 'assets/arrow_back_logo.svg'
import { ICameraListItem } from 'models/IFrameInfo'
import { useNavigate } from 'react-router-dom'
import { COLORS } from 'styles/colors'
import { CardStandart } from 'ui/CardStandart'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'

type Step2Props = {
	cameraInfo: ICameraListItem
}

export const SelectTypeOfDigitization = (props: Step2Props) => {
	const { cameraInfo } = props
	const navigate = useNavigate()
	const handleNavigate = (path: string) => {
		navigate(path, { state: cameraInfo })
	}

	const options = [
		{
			title: 'Отложенная оцифровка ( за прошлый период )',
			path: `/cattles/deffered-digitization/${cameraInfo.id}`,
		},
		{
			title: 'Оцифровка ( в режиме реального времени )',
			path: `/cattles/digitization/${cameraInfo.id}`,
		},
	]
	return (
		<Box
			marginBottom={'12px'}
			padding={'0px 24px 14px 24px'}
			display='flex'
			flexDirection='column'
			gap='16px'
		>
			{options.map(el => (
				<CardStandart
					key={el.title}
					onClick={() => handleNavigate(el.path)}
					sx={{
						border: `1px solid ${COLORS.inputBorder}`,
						padding: '24px',
						cursor: 'pointer',
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<TypographyPrimary16Bold>{el.title}</TypographyPrimary16Bold>
					<NextIcon style={{ transform: 'rotate(180deg)' }} />
				</CardStandart>
			))}
		</Box>
	)
}
